import { EraseAccountPanel } from "@amtana/account-client";
import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { ACCOUNT_ERROR_COPY } from "./model/account-error-copy.ts";
import { MY_ACCOUNT_CATALOGS } from "./model/my-account-copy.ts";

export const accountBrowserModule: BrowserModule = defineBrowserModule("account")
  .withErrorCopy(ACCOUNT_ERROR_COPY)
  .withLends([{ token: EraseAccountPanel, load: () => import("./ui/sections/erase-account-panel.tsx") }])
  .withScreens({
    myAccount: {
      path: "/my-account",
      title: phrase(MY_ACCOUNT_CATALOGS, "screenTitleMyAccount"),
      layout: "app",
      load: () => import("./ui/sections/my-account-screen.tsx"),
    },
    security: {
      path: "/security",
      title: phrase(MY_ACCOUNT_CATALOGS, "screenTitleSecurity"),
      layout: "app",
      load: () => import("./ui/sections/security-screen.tsx"),
    },
    usage: {
      path: "/usage",
      title: phrase(MY_ACCOUNT_CATALOGS, "screenTitleUsage"),
      layout: "app",
      load: () => import("./ui/sections/usage-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "profile",
      group: "settings-you",
      label: phrase(MY_ACCOUNT_CATALOGS, "profile"),
      href: "/my-account",
      icon: "user",
      order: 800,
    },
    {
      id: "security",
      group: "settings-you",
      label: phrase(MY_ACCOUNT_CATALOGS, "security"),
      href: "/security",
      icon: "shield-check",
      order: 805,
    },
    {
      id: "usage",
      group: "settings-billing",
      label: phrase(MY_ACCOUNT_CATALOGS, "usage"),
      href: "/usage",
      icon: "gauge",
      order: 930,
    },
  ]);
